import React, { forwardRef } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const DashboardIcon = forwardRef((props, ref) => (
  <SvgIcon
    {...props}
    ref={ref}
    viewBox="0 0 24 24"
    data-fill-none
  >
    <path
      d="M11.3672 2.63137C11.2607 2.54623 11.1296 2.5 10.9946 2.5C10.8596 2.5 10.7285 2.54623 10.622 2.63137L2 9.52689L2.7458 10.4943L3.8 9.6512V18.2692C3.80063 18.5954 3.92727 18.9081 4.15217 19.1388C4.37708 19.3695 4.68194 19.4993 5 19.5H17C17.3181 19.4993 17.6229 19.3695 17.8478 19.1388C18.0727 18.9081 18.1994 18.5954 18.2 18.2692V9.65674L19.2542 10.4998L20 9.53243L11.3672 2.63137ZM12.2 18.2692H9.8V12.346H12.2V18.2692ZM13.4 18.2692V12.346C13.3997 12.0197 13.2732 11.7068 13.0482 11.4761C12.8232 11.2453 12.5182 11.1156 12.2 11.1152H9.8C9.48184 11.1156 9.1768 11.2453 8.95182 11.4761C8.72685 11.7068 8.60032 12.0197 8.6 12.346V18.2692H5V8.6918L11 3.89786L17 8.69795V18.2692H13.4Z"
      fill="currentColor"
    />
  </SvgIcon>
));
